import { Image } from 'shared/ui'

import styles from './SupportItem.module.scss'

interface SupportItemProps {
  qr: string
  link: string
  linkLabel: string
  text: string
  label: string
  logo: string
}

export function SupportItem({
  label,
  link,
  logo,
  qr,
  text,
  linkLabel,
}: SupportItemProps) {
  return (
    <div className={styles.supportItem}>
      <div className={styles.qr}>
        <div className={styles.qrWrapper}>
          <Image src={qr} alt="qrcode" width={248} height={248} />
        </div>
        <div className={styles.iconWrapper}>
          <Image
            className={styles.icon}
            src={logo}
            alt={label}
            width={29}
            height={29}
          />
        </div>
      </div>
      <div className={styles.content}>
        <h4 className={styles.label}>{label}</h4>
        <p className={styles.text}>{text} </p>
        <a href={link} className={styles.link}>
          {linkLabel}
        </a>
      </div>
    </div>
  )
}
